import Loader from "Components/Loader";
import Scaffold from "Components/Scaffold";
import YearVisuals from "./Visuals/YearVisuals";
import WeekVisuals from "./Visuals/WeekVisuals";
import MonthVisuals from "./Visuals/MonthVisuals";
import DayVisuals from "./Visuals/DayVisuals";
import { useGetSalesOverviewQuery } from "hooks/Dashboard/useGetSalesOverviewQuery";
import { Empty } from "antd";

const SalesOverviewGraph = ({
  timePeriod,
  customEndDate,
  customStartDate,
}: {
  timePeriod: string;
  customStartDate?: string;
  customEndDate?: string;
}) => {
  const { data, isLoading } = useGetSalesOverviewQuery({
    timePeriod: timePeriod,
    customEndDate: customEndDate,
    customStartDate: customStartDate,
  });

  return (
    <Scaffold left="Sales Report" className="p-0 text-[15px]">
      <div className="p-4">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="text-[5px]">
            {timePeriod === "year" && data?.data.length > 0 && (
              <YearVisuals data={data?.data} />
            )}
            {timePeriod === "week" && data?.data.length > 0 && (
              <WeekVisuals data={data?.data} />
            )}
            {timePeriod === "month" && data?.data.length > 0 && (
              <MonthVisuals data={data?.data} />
            )}
            {timePeriod === "day" && data?.data.length > 0 && (
              <DayVisuals data={data?.data} />
            )}
          </div>
        )}
      </div>
    </Scaffold>
  );
};

export default SalesOverviewGraph;
